import { isApiErrorCode } from "@boomap/contracts";

import type { Messages } from "../i18n/index.ts";
import { ApiRequestError } from "./api-client.ts";

/**
 * Traduit une erreur d'API en texte affichable.
 *
 * Le texte vient du **code** métier, jamais du `message` renvoyé par l'API :
 * celui-ci est un diagnostic serveur, rédigé une fois pour toutes en français.
 * C'est précisément ce que garantit un contrat à codes stables — la traduction
 * vit là où vit la langue de l'interface.
 */
export const apiErrorMessage = (error: unknown, t: Messages, fallback: string): string =>
  error instanceof ApiRequestError && isApiErrorCode(error.code) ? t.errors[error.code] : fallback;
